// extracted by mini-css-extract-plugin
export default {"container":"Settings_container__m5f19","subContainer":"Settings_subContainer__wwy9r","leftArrow":"Settings_leftArrow__R9Hbv"};